export const DEFAULT_WEATHER_PARAMS = {
  start_date: "2025-01-01",
  end_date: "2025-12-31",
  latitude: 36.58485269711796, // 3CE HQ
  longitude: -121.85362884447532, // 3CE HQ
  daily: [
    "temperature_2m_max",
    "precipitation_sum",
    "relative_humidity_2m_max",
  ],
  timezone: "America/Los_Angeles" as const,
  temperature_unit: "fahrenheit" as const,
  wind_speed_unit: "mph" as const,
  precipitation_unit: "inch" as const,
};

export const COORDINATES = {
  "3CE": {
    latitude: DEFAULT_WEATHER_PARAMS.latitude,
    longitude: DEFAULT_WEATHER_PARAMS.longitude,
  },
};

export const TIME_ZONES = {
  "3CE": "America/Los_Angeles",
};
